<div #group class="code-input" role="group" [attr.aria-label]="label()" (focusout)="onFocusOut($event, group)">
  @for (char of cellValues(); track $index) {
    <input
      #cell
      class="code-input__cell"
      type="text"
      inputmode="text"
      autocapitalize="off"
      spellcheck="false"
      data-testid="code-input-cell"
      [class.code-input__cell--invalid]="invalid()"
      [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
      [attr.aria-label]="`${label()} ${$index + 1}`"
      [attr.aria-invalid]="invalid()"
      [value]="char"
      [disabled]="isDisabled()"
      (input)="onInput($index, $event)"
      (keydown)="onKeydown($index, $event)"
      (paste)="onPaste($index, $event)"
      (focus)="onFocus($event)" />
  }
</div>
